export const messageErroProposalNotification = 'Uma proposta sua teve uma alteração no seu status.'
export const titleErroProposalNotification = 'Proposta atualizada.'
